var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallPencilIcon = function SvgSmallPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    fill: "none",
    viewBox: "0 0 7 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.511 1.132 4.537.108l.011-.012A.31.31 0 0 1 4.769 0c.063 0 .124.023.17.068l.04.04 1.047 1.046a.24.24 0 0 1 .066.19.32.32 0 0 1-.095.201L2.929 4.613l-.495.494-.495-.494-.953-.954zm.495.495.752-.75.459.458-2.783 2.783-.459-.46zM2.05 5.577 0 6.09l.512-2.05.769.77z"
  })));
};
export default SvgSmallPencilIcon;